import { render } from "./Create25Liquidation3.vue?vue&type=template&id=eb4c5910"
import script from "./Create25Liquidation3.vue?vue&type=script&lang=js"
export * from "./Create25Liquidation3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__